/** use after onMounted */
export function useVerticalCollapsible(
  dom: HTMLElement,
  options: {
    frames?: number
    callback?: {
      collapsed?: () => void
      expanded?: () => void
    }
    initCollapsed?: boolean
  } = {},
): (flag: boolean) => void {
  const { frames = 9, callback, initCollapsed } = options
  const maxHeight = dom.style.maxHeight
  let dynamicMaxHeight = initCollapsed ? 0 : dom.clientHeight
  let fullHeight: number
  let step: number
  let animating: boolean
  let id: number

  function collapse() {
    if (dynamicMaxHeight > 0) {
      if (dynamicMaxHeight < step) {
        dynamicMaxHeight = 0
      } else {
        dynamicMaxHeight -= step
      }

      dom.style.maxHeight = `${dynamicMaxHeight}px`

      id = requestAnimationFrame(collapse)
    } else {
      animating = false
      callback?.collapsed?.()
    }
  }

  function expand() {
    if (dynamicMaxHeight < fullHeight) {
      if ((dynamicMaxHeight + step) < fullHeight) {
        dynamicMaxHeight += step
      } else {
        dynamicMaxHeight = fullHeight
      }

      dom.style.maxHeight = `${dynamicMaxHeight}px`

      id = requestAnimationFrame(expand)
    } else {
      animating = false
      dom.style.maxHeight = maxHeight
      callback?.expanded?.()
    }
  }
  if (initCollapsed) {
    dom.style.maxHeight = '0px'
    callback?.collapsed?.()
  } else {
    callback?.expanded?.()
  }

  return (flag: boolean): void => {
    cancelAnimationFrame(id)

    if (flag) {
      if (!animating) {
        dynamicMaxHeight = dom.clientHeight
      }

      step = Math.ceil(dynamicMaxHeight / frames)
      animating = true

      id = requestAnimationFrame(collapse)
    } else {
      fullHeight = dom.scrollHeight
      step = Math.ceil(fullHeight / frames)
      animating = true

      id = requestAnimationFrame(expand)
    }
  }
}
